module.exports = __webpack_public_path__ + "static/media/screenshot_quiz_cropped_purple.4ffa9a81.svg";